<template>
  <div class="rm-drawer-step">
    <div class="rm-drawer-scroll">
      <section v-if="selectedRepairerOffer" class="drawer-section">
        <v-card class="repairer-validation-offer-card pa-3" color="primary" variant="tonal">
          <div class="secondary-card-row w-100">
            <p class="drawer-offer-label">
              {{ $t('COMMON.PRODUCT_END_STATUS.' + selectedRepairerOffer.offer_type) }}
            </p>
            <p class="ml-auto drawer-offer-price">
              {{ Number(selectedRepairerOffer.total_cost).toFixed(2) }} {{ $t('COMMON.EURO') }}
            </p>
          </div>
          <div class="repairer-offer-detail">
            <div class="repairer-offer-detail-content">
              <div class="repairer-choice-metrics">
                <div class="secondary-card--soft repairer-choice-metric">
                  <p class="repairer-choice-metric-label">
                    {{
                      $t(
                        isReplacementEstimateOffer(selectedRepairerOffer)
                          ? 'COMMON.COST'
                          : 'ESTIMATE_REPAIRER_CLIENT_CHOICE.TRANSPORT_COST'
                      )
                    }}
                  </p>
                  <p class="repairer-choice-metric-value">
                    {{ repairerCost(selectedRepairerOffer).toFixed(2) }} {{ $t('COMMON.EURO') }}
                  </p>
                </div>
                <div class="secondary-card--soft repairer-choice-metric">
                  <p class="repairer-choice-metric-label">
                    {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE.MARGIN') }}
                  </p>
                  <p class="repairer-choice-metric-value">
                    {{ selectedRepairerOffer.margin }} {{ $t('COMMON.PERCENT') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </section>

      <section class="drawer-section">
        <v-card-secondary>
          <h3 class="secondary-card-title">
            {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.TITLE') }}
          </h3>

          <v-row dense>
            <v-col cols="12" class="repairer-validation-column repairer-validation-column--left">
              <h4 class="text-body-2 font-weight-bold mb-2">
                {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.SUB_TITLE.CONTACT_REPAIRER') }}
              </h4>

              <div class="detail-info-row">
                <span class="detail-info-label">
                  {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.LABEL.REPAIRER_PRICE') }}
                </span>
                <strong class="detail-info-value">
                  {{ repairerPrice?.toFixed(2) }} {{ $t('COMMON.EXCLUSIVE_TAX') }}
                </strong>
              </div>
              <div class="detail-info-row">
                <span class="detail-info-label">
                  {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.LABEL.REPAIRER_PHONE') }}
                </span>
                <strong class="detail-info-value">{{ repairerCenterPhoneNumber }}</strong>
              </div>
              <div class="detail-info-row">
                <span class="detail-info-label">
                  {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.LABEL.REPAIRER_EMAIL') }}
                </span>
                <strong class="detail-info-value">{{ repairerCenterEmail }}</strong>
              </div>
            </v-col>

            <v-col cols="12" class="repairer-validation-column repairer-validation-column--right">
              <h4 class="text-body-2 font-weight-bold mb-2">
                {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.SUB_TITLE.CONTACT_CLIENT') }}
              </h4>

              <div class="detail-info-row">
                <span class="detail-info-label">
                  {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.LABEL.CUSTOMER_PHONE') }}
                </span>
                <strong class="detail-info-value">{{ customerPhoneNumber }}</strong>
              </div>
              <div class="detail-info-row">
                <span class="detail-info-label">
                  {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.LABEL.CUSTOMER_EMAIL') }}
                </span>
                <strong class="detail-info-value">{{ customerEmail }}</strong>
              </div>
            </v-col>
          </v-row>
        </v-card-secondary>
      </section>
    </div>
  </div>
</template>

<script>
import { displayToast, handleResponseError } from '@/utils/toastUtils'
import RepairFileService from '@/services/RepairFileService'
import RepairCenterService from '@/services/RepairCenterService'
import { isReplacementEstimateOffer } from '@/utils/repairFileUtils'

export default {
  props: { currentRepairFile: Object },
  data() {
    return {
      loading: false,
      repairerPrice: null,
      selectedRepairerOffer: null,
      repairerCenterPhoneNumber: null,
      repairerCenterEmail: null,
      customerPhoneNumber: null,
      customerEmail: null
    }
  },
  computed: {
    footerState() {
      return { disabled: this.loading, loading: this.loading }
    }
  },
  async created() {
    await this.patchData()
  },
  mounted() {
    this.emitFooterState()
  },
  watch: {
    footerState: {
      handler() {
        this.emitFooterState()
      },
      deep: true
    }
  },
  methods: {
    isReplacementEstimateOffer,
    emitFooterState() {
      this.$emit('updateFooterState', this.footerState)
    },
    repairerCost(offer) {
      return offer.estimate_cost + offer.transport_cost + offer.labor_cost
    },
    async submit() {
      this.loading = true
      try {
        await RepairFileService.saveRepairerEstimateOptionClientChoiceFromManualSelection({
          repair_file_id: this.currentRepairFile.technical_id,
          repairer_estimate_option_id: this.selectedRepairerOffer.technical_id,
          margin: this.selectedRepairerOffer.margin,
          total_cost: this.selectedRepairerOffer.total_cost
        })
        displayToast(this.$t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.VALIDATION'), 'success')
        this.$emit('updateCurrentRepairFile')
        this.$emit('cancelEstimateRepairer')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getRepairCenter() {
      const response = await RepairCenterService.getRepairCenterDetailByRepairFile(
        this.currentRepairFile.technical_id
      )
      this.repairerCenterPhoneNumber = response.phone_number
      this.repairerCenterEmail = response.contact_email
    },
    async patchData() {
      this.selectedRepairerOffer =
        this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.find(
          (offer) => offer.is_selected === true
        )
      this.customerPhoneNumber = this.currentRepairFile.phone_number
      this.customerEmail = this.currentRepairFile.email
      if (this.selectedRepairerOffer) {
        this.repairerPrice =
          this.selectedRepairerOffer.estimate_cost + this.selectedRepairerOffer.transport_cost
      }
      await this.getRepairCenter()
    }
  }
}
</script>

<style scoped>
.repairer-validation-offer-card {
  background: rgba(var(--v-theme-primary), 0.12);
  border-color: rgba(var(--v-theme-primary), 0.25);
}

@media (min-width: 960px) {
  .repairer-validation-column--left {
    padding-right: 8px !important;
  }

  .repairer-validation-column--right {
    padding-left: 8px !important;
  }
}
</style>
